<template>
  <div>
    <vx-card>
      <h4 class="mb-1">{{ $t('campaign.approvals') }}</h4>
      <small class="text-muted d-block mb-3">{{ $t('campaign.approvals_hint') }}</small>

      <div v-if="isLoading" class="text-center py-4">
        <span class="text-muted">{{ $t('loading') }}</span>
      </div>

      <div v-else-if="!pending.length" class="text-center py-4">
        <feather-icon icon="CheckCircleIcon" class="h-8 w-8 text-success mb-1"/>
        <p class="text-muted mb-0">{{ $t('campaign.approvals_empty') }}</p>
      </div>

      <div v-else>
        <div v-for="c in pending" :key="c.id" class="approval-row">
          <div class="approval-main">
            <div class="font-medium">{{ c.name }}</div>
            <small class="text-muted d-block">{{ _.get(c, 'legal_entity.name') }}</small>
            <div class="mt-1">
              <vs-chip transparent color="primary" class="mr-1">
                {{ $t('campaign.discount') }}: {{ amountLabel(c.discount_type, c.discount_amount) }}
              </vs-chip>
              <vs-chip transparent color="warning" class="mr-1">
                {{ $t('campaign.commission') }}: {{ amountLabel(c.commission_type, c.commission_amount) }}
              </vs-chip>
              <vs-chip transparent color="dark">
                {{ (c.campaign_products || []).length }} {{ $t('campaign.products_count') }}
              </vs-chip>
            </div>
            <p v-if="c.briefing" class="mt-1 mb-0 text-muted small">{{ c.briefing }}</p>
          </div>
          <div class="approval-actions">
            <b-button size="sm" variant="outline-primary" @click="openDetail(c)">
              {{ $t('campaign.see_detail') }}
            </b-button>
            <b-button size="sm" variant="success" @click="accept(c)">{{ $t('campaign.accept') }}</b-button>
            <b-button size="sm" variant="outline-danger" @click="refuse(c)">{{ $t('campaign.refuse') }}</b-button>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import CampaignService from '@/services/api/CampaignService'

export default {
  components: { BButton },
  data: () => ({ service: null, pending: [], isLoading: false }),
  methods: {
    load() {
      this.isLoading = true
      this.service.awaitingApproval().then(
        list => { this.pending = list || [] },
        () => { this.pending = [] }
      ).finally(() => { this.isLoading = false })
    },
    amountLabel(type, amount) {
      const n = Number(amount || 0)
      return type === 'VA'
        ? n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        : `${n}%`
    },
    openDetail(c) { this.$router.push(`/campaigns/${c.id}/detail`) },
    accept(c) {
      this.$vs.loading()
      this.service.approve(c.id).then(
        () => { this.notifySuccess(this.$vs, this.$t('messages.success')); this.load() },
        error => this.showErrors(this.$validator, error, this)
      ).finally(() => { this.$vs.loading.close() })
    },
    refuse(c) {
      const reason = window.prompt(this.$t('campaign.reason_prompt'))
      if (reason === null) return

      this.$vs.loading()
      this.service.reject(c.id, reason || '').then(
        () => { this.notifySuccess(this.$vs, this.$t('messages.success')); this.load() },
        error => this.showErrors(this.$validator, error, this)
      ).finally(() => { this.$vs.loading.close() })
    }
  },
  beforeMount() { this.service = CampaignService.build(this.$vs) },
  mounted() { this.load() }
}
</script>

<style scoped>
.approval-row {
  display: flex; align-items: flex-start; justify-content: space-between;
  gap: 1rem; padding: 0.85rem 0; border-bottom: 1px solid rgba(0,0,0,0.08);
}
.approval-row:last-child { border-bottom: none; }
.approval-main { flex: 1; min-width: 0; }
.approval-actions { display: flex; gap: 0.5rem; flex-shrink: 0; }
</style>
